import { jsx as _jsx } from "react/jsx-runtime";
/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { Box } from '@gemini/core';
import { useOfferCard } from '@/hooks/useOfferCard';
import { OFFER_CARD_CONTENT_HEIGHT } from './constants';
import { OfferCardFeatureList } from './OfferCardFeatureList';
export function OfferCardContentDesktop() {
    const { featuresTitle, features } = useOfferCard();
    return (_jsx(Box, { testId: "offer-card-content", minHeight: OFFER_CARD_CONTENT_HEIGHT, paddingVertical: "spacing.24", paddingHorizontal: "spacing.16", backgroundColor: "color.background.light", display: "flex", flex: 1, flexDirection: "column", gap: "spacing.16", children: _jsx(Box, { marginHorizontal: "spacing.none", children: _jsx(OfferCardFeatureList, { featuresTitle: featuresTitle, features: features }) }) }));
}
